<template>
  <div>
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h3 class="title has-text-white">{{ titulo }}</h3>
          <div class="box app-justification-box">
            <p class="descricao">
              {{ ajuste ? 'Defina a nova' : 'Escolha a' }}
              <strong>duração do relógio</strong> para a manifestação de intenção de recurso. Após o
              término, os licitantes não poderão mais manifestar.
            </p>

            <form @submit.prevent="confirmar">
              <div class="duracao-row">
                <label class="duracao-label" for="duracao-manifestacao-minutos">
                  Duração (minutos)
                  <b-tooltip :label="textoLimites" position="is-bottom" multilined>
                    <b-icon icon="help-circle" size="is-small" class="has-text-grey is-clickable" />
                  </b-tooltip>
                </label>
                <div class="duracao-field">
                  <b-field :type="campoInvalido ? 'is-danger' : ''" :message="mensagemErro">
                    <b-input
                      id="duracao-manifestacao-minutos"
                      v-model.number="duracaoMinutos"
                      type="number"
                      :min="minMinutos"
                      :max="maxMinutos"
                      step="1"
                      placeholder="Ex.: 30"
                      icon="clock"
                    />
                  </b-field>
                </div>
              </div>

              <p v-if="duracaoResumo" class="resumo">
                <strong>Relógio:</strong> {{ duracaoResumo }}
              </p>

              <div class="buttons-container">
                <button
                  class="button is-primary rm-1"
                  type="button"
                  :class="{ 'is-loading': loading }"
                  :disabled="loading || !podeConfirmar"
                  @click.prevent="confirmar"
                >
                  {{ ajuste ? 'Confirmar' : 'Iniciar Relógio' }}
                </button>
                <button class="button" type="button" :disabled="loading" @click.prevent="fechar">
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
const MAX_MINUTOS_DEFAULT = 24 * 60;
const MIN_MINUTOS_DEFAULT = 10;

export default {
  name: 'PrazoManifestacaoIntencaoDialog',
  props: {
    titulo: {
      type: String,
      default: 'Iniciar Manifestação',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    ajuste: {
      type: Boolean,
      default: false,
    },
    limites: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      duracaoMinutos: null,
    };
  },
  computed: {
    minMinutos() {
      const valor = Number(this.limites?.minMinutos);
      return Number.isFinite(valor) && valor >= 1 ? Math.floor(valor) : MIN_MINUTOS_DEFAULT;
    },
    maxMinutos() {
      const valor = Number(this.limites?.maxMinutos);
      return Number.isFinite(valor) && valor >= 1 ? Math.floor(valor) : MAX_MINUTOS_DEFAULT;
    },
    textoLimites() {
      return `Mínimo: ${this.minMinutos} min · Máximo: ${this.maxMinutos} min (24h)`;
    },
    campoInvalido() {
      if (this.duracaoMinutos === null || this.duracaoMinutos === '') return false;
      const valor = Number(this.duracaoMinutos);
      if (!Number.isInteger(valor)) return true;
      return valor < this.minMinutos || valor > this.maxMinutos;
    },
    mensagemErro() {
      if (!this.campoInvalido) return '';
      return `Informe um valor inteiro entre ${this.minMinutos} e ${this.maxMinutos} minutos.`;
    },
    duracaoResumo() {
      const valor = Number(this.duracaoMinutos);
      if (!Number.isInteger(valor) || valor < 1) return null;
      if (valor < 60) return `${valor} minuto(s)`;
      const horas = Math.floor(valor / 60);
      const minutos = valor % 60;
      if (minutos === 0) return `${horas}h`;
      return `${horas}h ${minutos}min`;
    },
    podeConfirmar() {
      const valor = Number(this.duracaoMinutos);
      return Number.isInteger(valor) && valor >= this.minMinutos && valor <= this.maxMinutos;
    },
  },
  watch: {
    minMinutos: {
      immediate: true,
      handler(min) {
        if (this.duracaoMinutos == null) {
          this.duracaoMinutos = min;
        }
      },
    },
  },
  methods: {
    fechar() {
      this.$parent.onCancel();
      this.$parent.close();
    },
    confirmar() {
      if (!this.podeConfirmar) return;

      const duracaoMinutos = Number(this.duracaoMinutos);
      const resumo = this.duracaoResumo;

      this.$buefy.dialog.confirm({
        title: this.ajuste ? 'Confirmar ajuste do relógio' : 'Confirmar início do relógio',
        message: `Deseja ${
          this.ajuste ? 'ajustar' : 'iniciar'
        } o relógio por <strong>${resumo}</strong>?`,
        confirmText: this.ajuste ? 'Confirmar' : 'Iniciar Relógio',
        cancelText: 'Voltar',
        type: 'is-primary',
        hasIcon: true,
        onConfirm: () => {
          this.$parent.$emit('confirmar-prazo-manifestacao-intencao', {
            duracaoMinutos,
          });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons-container {
  margin-top: 1rem;
  text-align: center;
}

.app-justification-box {
  width: max-content;
  max-width: min(720px, 95vw);
  min-width: min(420px, 95vw);
  text-align: left;
}

.descricao {
  margin-bottom: 1rem;
}

.duracao-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.duracao-label {
  margin: 0;
  font-weight: 600;
  white-space: nowrap;
  color: #363636;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.resumo {
  margin-top: 0.75rem;
  font-size: 0.95rem;
}

.rm-1 {
  margin-right: 3px;
}

@media (max-width: 768px) {
  .app-justification-box {
    min-width: unset;
    width: 100%;
    max-width: 90vw;
  }
}
</style>

<style lang="scss">
/* b-modal remonta o conteúdo; scoped não alcança o .input do Buefy. */
.duracao-field {
  width: 8rem;
  flex: 0 0 8rem;

  .field {
    margin-bottom: 0;
  }

  .control,
  .input {
    width: 8rem !important;
    max-width: 8rem !important;
  }
}
</style>
